import { render, staticRenderFns } from "./UserRules.vue?vue&type=template&id=cf67d640"
import script from "./UserRules.vue?vue&type=script&lang=js"
export * from "./UserRules.vue?vue&type=script&lang=js"
import style0 from "./UserRules.vue?vue&type=style&index=0&id=cf67d640&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports